module.exports = __webpack_public_path__ + "img/aerospace-paths.800b16d5.jpg";